import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { BsTrash3 } from "react-icons/bs";
import { ButtonCustom } from "../../../../components/sharedComponents/ButtonCustom";
import { Modals } from "../../../../components/sharedComponents/Modals";
import { BusyTimeModal } from "./BusyTimeModal";
import { toast } from "react-toastify";
import { CallAPI } from "../../../../config/api/ApiConfig";
import { dateWithMonth, yearMonthDay } from "../../../../constants/constants";
import axios from "axios";
import { AuthContext } from "../../../../auth/AuthProvider";
import { AxiosContext } from "../../../../config/api/AxiosConfig";

export const BusyTimes = () => {
  const { messages, locale } = useIntl();
  const { user } = useContext(AuthContext);
  const { setLoader } = useContext(AxiosContext);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDates, setSelectedDates] = useState([]);
  const timeData = [{ startTime: "00:00", endTime: "00:05" }];
  const [vacation, setVacation] = useState(false);
  const [deletedDay, setdeletedDay] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: {
      data: timeData,
    },
  });

  const { data: customTime, refetch } = CallAPI({
    name: "CustomTimeGet",
    url: "/mentor/v1/auth/availability",
    refetchOnWindowFocus: false,
    select: (res) => res?.data?.data,
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  CallAPI({
    name: ["deleteDay", deletedDay],
    url: "/mentor/v1/auth/availability/delete-day",
    refetchOnWindowFocus: false,
    method: "post",
    body: {
      day: deletedDay,
    },
    select: (res) => res?.data,
    onSuccess: (res) => {
      if (res?.success) {
        setdeletedDay(false);
        refetch();
      }
    },
    enabled: deletedDay ? true : false,
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const updateCustomTime = async () => {
    const formData = new FormData();
    watch("data")?.forEach((langId, index) => {
      if (vacation) {
        formData.append(`exceptions[${yearMonthDay(selectedDate)}]`, `""`);
      } else {
        formData.append(
          `exceptions[${yearMonthDay(selectedDate)}]`,
          `${langId.startTime}, ${langId.endTime}`
        );
      }
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/mentor/v1/auth/update-availability`,
        formData,
        {
          headers: {
            "Accept-Language": localStorage.getItem("locale") || "en",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (response) {
        toast.success(response?.data?.message);
        refetch();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  };

  const onSubmit = (data) => {
    setLoader(true);
    updateCustomTime();
    closeModal();
  };

  const closeModal = () => {
    setOpenCalendar(false);
    setValue("data", timeData);
    setSelectedDate(new Date());
    setVacation(false);
  };

  const handleAddNewDate = () => {
    setOpenCalendar(true);
    setValue("data", timeData);
  };

  const handleDateSelect = (date) => {
    console.log(date);
    // Format the date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (selectedDates.includes(formattedDate)) {
      toast.error(messages["date_already_exists"] + " " + formattedDate);
      return;
    }

    setSelectedDates((prev) => [...prev, formattedDate]);
  };

  const handleConfirm = async () => {
    setLoader(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/mentor/v1/dates_excluded/update`,
        { dates: selectedDates },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Accept-Language": localStorage.getItem("locale") || "en",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (response) {
        toast.success(response?.data?.message);
        refetch();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  };

  const removeDate = (index) => {
    const newDates = [...selectedDates];
    newDates.splice(index, 1);
    setSelectedDates(newDates);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_DOMAIN}/mentor/v1/dates_excluded`,
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
              Accept: "application/json",
              "Accept-Language": localStorage.getItem("locale") || "en",
            },
          }
        );

        if (response) {
          setSelectedDates(response?.data?.data);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      } finally {
        setLoader(false);
      }
    })();
  }, []);

  return (
    <>
      <h2 className="heading_dash text-center text-md-start mt-5">
        <small>{messages["not_available"]}</small>
      </h2>
      <div className="custom-times">
        {selectedDates.map((date, index) => (
          <div key={index} className="custom-div">
            <div className="first-section">
              <div className="d-flex justify-content-between">
                <div className="date">
                  {messages["date"]}: {dateWithMonth(date)}
                </div>
                <div className="icons">
                  <BsTrash3 onClick={() => removeDate(index)} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="d-flex gap-2">
        <ButtonCustom
          className="w-100 add-new"
          text="add.new"
          hasIcon="+ "
          onClick={handleAddNewDate}
        />
        <ButtonCustom
          className="w-100 confirm"
          text="confirm"
          onClick={handleConfirm}
        />
      </div>
      <Modals
        title="custom.available.time"
        body={
          <BusyTimeModal
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            selectedDate={selectedDates}
            setSelectedDate={setSelectedDate}
            register={register}
            watch={watch}
            errors={errors}
            setOpenCalendar={setOpenCalendar}
            clearErrors={clearErrors}
            openCalendar={openCalendar}
            closeModal={closeModal}
            vacation={vacation}
            setVacation={setVacation}
            onDateSelect={handleDateSelect}
          />
        }
        open={openCalendar ? true : false}
        handleClose={() => {
          closeModal();
        }}
        onClickSend={() => {}}
        size="md"
        showfooter={false}
      />
    </>
  );
};
